export default __webpack_public_path__ + "static/media/learose3-1024w.e0f887c7.webp";